module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    staticClass: "sound"
  }, _vm._l((_vm.visualizationSounds), function(sound, index) {
    return _c('g', {
      key: index,
      attrs: {
        "transform": ("translate(" + (sound.positionX) + " -" + (sound.positionY) + ")")
      }
    }, [_c('use', {
      attrs: {
        "x": "-2",
        "y": "-2",
        "width": "4",
        "height": "4",
        "xlink:href": ("#sound-volum" + (_vm.level(sound.sound)))
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a541aba","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/layer/sound.vue
// module id = 897
// module chunks = 0